import { apiGet } from '../../fetch/apiService';

export function getGroups(credentialsId) {
	return apiGet(`data-sources/sonos/get-groups/${credentialsId}`, {}, { adminApi: true });
}
